import WebsiteInfoWysiwygStore from '../../../stores/websiteInfoWysiwygStore';

const franchiseStore = new WebsiteInfoWysiwygStore('v3/info/franchise', 'v4/website-info/franchise', 'franchiseStore');
export default franchiseStore;
